
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

type NoSearchResultsProps = {
  searchQuery: string;
};

export const NoSearchResults = ({ searchQuery }: NoSearchResultsProps) => {
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Your Knowledge Base</h1>
        <Link to="/dashboard/new-entry">
          <Button>
            <Plus className="mr-2 h-4 w-4" />
            New Entry
          </Button>
        </Link>
      </div>
      <div className="text-center py-12">
        <h3 className="text-lg font-medium mb-2">No entries found</h3>
        <p className="text-muted-foreground mb-4">
          No entries match your search: "{searchQuery}"
        </p>
      </div>
    </div>
  );
};
